import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { trackPurchase } from "../../utils/gaAnalytics";
import { useGetOrderDetailsQuery } from "../../slices/ordersApiSlice";
import Meta from "../../components/Meta";

const OrderCompleteScreen = () => {
    const navigate = useNavigate();
    // 最新の注文情報を取得する（直前の注文IDは OrderScreen から遷移してくる）
    // この画面は '/order-complete' 固定のため、厳密な orderId は取得できないケースあり。
    // その場合は直近の注文情報をバックエンドで返す API があれば理想だが、
    // ここではカート情報（が残っていれば）をフォールバックとして使う。
    const cart = useSelector((state) => state.cart);
    // 取得APIがなければ、この import は将来用のために残す
    const { data: order } = { data: null };

    useEffect(() => {
        // order があれば優先して purchase を送る。なければ cart から推測して送る。
        if (order) {
            trackPurchase(
                order.id,
                [...(order.PurchaseItems || []), ...(order.RentalItems || [])].map((it) => ({
                    id: it.productId,
                    productId: it.productId,
                    name: it.name,
                    shopName: it.shopName,
                    finalPrice: it.finalPrice,
                    serviceOption: it.rentalPeriod ? 'rent' : 'buy',
                    rentalPeriod: it.rentalPeriod,
                    useSubscription: it.useSubscription,
                })),
                order.totalPrice,
                order.shippingPrice,
                order.taxPrice,
            );
        } else if (cart?.cartItems?.length) {
            // 最低限のフォールバック（transaction_id は日時などで生成した方が良いが、簡易実装）
            const fallbackTxId = `tx_${Date.now()}`;
            trackPurchase(
                fallbackTxId,
                cart.cartItems,
                cart.totalPrice,
                cart.shippingPrice,
                cart.taxPrice,
            );
        }
    }, [order, cart]);

    return (<>
        <Meta
            title='注文完了 | ふるぷら'
            description='ふるぷらの注文完了ページです。'
            robots='noindex, nofollow'
        />
        <div className="order-complete">
            <div className="order-complete__content">
                <svg
                    className="order-complete__package"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 64 64"
                    >
                    <rect
                        className="order-complete__package-body"
                        x="8"
                        y="24"
                        width="48"
                        height="32"
                        fill="#fff"
                        stroke="#ccc"
                        strokeWidth="2"
                    />
                    <rect
                        className="order-complete__package-lid"
                        x="8"
                        y="16"
                        width="48"
                        height="12"
                        fill="#502200"
                    />
                </svg>

                <div className="order-complete__confetti">
                    <span className="order-complete__confetti-piece order-complete__confetti-piece--1"></span>
                    <span className="order-complete__confetti-piece order-complete__confetti-piece--2"></span>
                    <span className="order-complete__confetti-piece order-complete__confetti-piece--3"></span>
                </div>

                <h1 className="order-complete__title">ご注文ありがとうございます！</h1>
                <p className="order-complete__message">
                    お支払いが完了しました。詳細情報は注文履歴をご確認ください。
                </p>
                <Button
                    className="order-complete__button"
                    variant="primary"
                    onClick={() => navigate('/order-history')}
                >
                    注文履歴を見る
                </Button>
            </div>
        </div>
    </>);
};

export default OrderCompleteScreen;